import { MyNotification } from '@borg/types';

class MyNotificationsRepository extends Repository<MyNotification> {
  override getMany() {
    return this._getMany({ url: '/ba/notifications' });
  }

  override delete(id: MyNotification['id']) {
    return this._delete({ url: `/me/notifications/${id}` });
  }

  deleteAll() {
    return this._delete({ url: `/me/notifications` });
  }

  read(id: MyNotification['id']) {
    return this._update({ url: `/ba/notifications/${id}/seen`, data: { seenBySubscriber: true } });
  }
}

export const myNotificationsRepository = new MyNotificationsRepository();
